import { Component, StrictMode, type ErrorInfo, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConvexProvider } from 'convex/react';

import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';

import { convex } from './lib/convex';
import { SignInPage } from './routes/SignIn';
import { DashboardPage } from './routes/Dashboard';

class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught', error, info);
  }
  render() {
    if (this.state.hasError) return <p>Something went wrong.</p>;
    return this.props.children;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <ConvexProvider client={convex}>
        {/*
          The admin SPA is served at the root of its own subdomain
          (admin.wydm.app) via Cloudflare Pages, so React Router runs
          without a basename. Vite's `base: '/'` handles asset URLs
          symmetrically.
        */}
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/auth/signin" replace />} />
            <Route path="/auth/signin" element={<SignInPage />} />
            <Route path="/dashboard/*" element={<DashboardPage />} />
          </Routes>
        </BrowserRouter>
      </ConvexProvider>
    </ErrorBoundary>
  </StrictMode>
);
